// src/components/store/sections/testimonials/TestimonialV38CardsliderSunsetAmber.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV38CardsliderSunsetAmber(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={38}
      archKey="card_slider"
      archLabel="Review Card Carousel"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
